export default __webpack_public_path__ + "resources/icons/n103-2cd9.png";